export function fromModel(s){
   s=s==1?"安卓":s==2?"苹果":s==3?"安卓绿色通道":s==4?"苹果绿色通道":s==5?"管理后台":"未知"
    return s
}



// WEBPACK FOOTER //
// ./src/utils/fromModel.js